import axios from 'axios'

const cancelToken = axios.CancelToken

class LaboratoryTasksService {
    constructor() {
        this.sourceTasks = null
        this.sourceSummaryTasks = null
    }

    cancelTasksCall() {
        if (this.sourceTasks) {
            this.sourceTasks.cancel()
            this.sourceTasks = null
        }
    }
    async getTasks(labId, sectionIds) {
        const params = { sectionIds: sectionIds }
        this.sourceTasks = cancelToken.source()
        const response =
            await axios.get(
                `/laboratory/laboratories/${labId}/tasks`,
                { params, cancelToken: this.sourceTasks.token })
        return response.data
    }

    cancelSummaryTasksCall() {
        if (this.sourceSummaryTasks) {
            this.sourceSummaryTasks.cancel()
            this.sourceSummaryTasks = null
        }
    }
    async getSummaryTasks(labId, sectionIds) {
        const params = { sectionIds: sectionIds }
        this.sourceSummaryTasks = cancelToken.source()
        const response =
            await axios.get(
                `/laboratory/laboratories/${labId}/summaryTasks`,
                { params, cancelToken: this.sourceSummaryTasks.token })
        return response.data
    }
}

export const laboratoryTasksService = new LaboratoryTasksService()
